import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57bf4d8b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Перевозка", -1))
const _hoisted_3 = { class: "flex items-center mt-2" }
const _hoisted_4 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_5 = {
  key: 1,
  class: "AdditionalServices"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "AdditionalServices__title" }, "Доп. услуги", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "AdditionalServices__warning" }, " ЕСЛИ ВЫ ПРЕДОСТАВИЛИ КЛИЕНТУ ДОП УСЛУГУ, ОБЯЗАТЕЛЬНО ЗАПОЛНИТЕ ПОЛЯ ДЛЯ ВЫСТАВЛЕНИЯ КЛИЕНТУ ", -1))
const _hoisted_8 = { class: "font-semibold" }
const _hoisted_9 = { class: "font-semibold mb-3" }
const _hoisted_10 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_11 = { class: "ServiceSubtitle" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ServiceSubtitle__hint" }, " Выберите компанию, которая предоставила вам грузчиков/авто/кран/рохлю. ", -1))
const _hoisted_13 = { class: "ServiceSubtitle" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ServiceSubtitle__hint" }, " Укажите стоимость доп услуги за час в тенге, если был взаимодействован сторонний поставщик. ", -1))
const _hoisted_15 = { class: "flex items-center" }
const _hoisted_16 = { class: "ServiceSubtitle" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ServiceSubtitle__hint" }, " Нажмите на галочку, если были отправлены грузчики/авто/кран/рохля Spark-а и не надо никому оплачивать за них. ", -1))
const _hoisted_18 = { class: "grid grid-cols-2 gap-3 mt-2" }
const _hoisted_19 = { class: "ServiceSubtitle" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ServiceSubtitle__hint" }, [
  /*#__PURE__*/_createTextVNode(" Укажите количество часов, отработанных "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-blue-500" }, "одним грузчиком"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_21 = { class: "ServiceSubtitle" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ServiceSubtitle__hint" }, " Укажите количество грузчиков/авто/крана/рохли, предоставленных клиенту. ", -1))
const _hoisted_23 = { class: "mt-2" }
const _hoisted_24 = { class: "ServiceSubtitle" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ServiceSubtitle__hint" }, [
  /*#__PURE__*/_createTextVNode(" Это поле считается автоматически по формуле "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-blue-500" }, "стоимость/часы * отработанные часы * количество")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_radio_group = _resolveComponent("radio-group")!
  const _component_info_icon = _resolveComponent("info-icon")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "xxl",
    title: "Заполните данные о доставке",
    loading: _ctx.isModalLoading,
    scrollable: "",
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.manageSubmitted
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        class: "w-full mt-2",
        type: "date",
        placeholder: "Дата доставки",
        value: _ctx.delivery_state.delivery_date,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.delivery_state.delivery_date) = $event)),
        "is-invalid": _ctx.state_form$.delivery_date.$error,
        "validation-errors": _ctx.state_form$.delivery_date.$errors
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        class: "w-full mt-2",
        placeholder: "Время доставки",
        maska: _ctx.TIME_MASK,
        value: _ctx.delivery_state.delivery_time,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.delivery_state.delivery_time) = $event)),
        "is-invalid": _ctx.state_form$.delivery_time.$error,
        "validation-errors": _ctx.state_form$.delivery_time.$errors
      }, null, 8, ["maska", "value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        class: "w-full mt-2",
        placeholder: "ФИО принявшего заказ",
        value: _ctx.delivery_state.received_by,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.delivery_state.received_by) = $event)),
        "is-invalid": _ctx.state_form$.received_by.$error,
        "validation-errors": _ctx.state_form$.received_by.$errors
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      (_ctx.isNeedCar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_the_input, {
                class: "w-full",
                placeholder: "Количество авто",
                value: _ctx.delivery_state.auto_count,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.delivery_state.auto_count) = $event)),
                "is-invalid": _ctx.state_form$.auto_count.$error,
                "validation-errors": _ctx.state_form$.auto_count.$errors
              }, null, 8, ["value", "is-invalid", "validation-errors"]),
              _createVNode(_component_the_input, {
                class: "w-full ml-2",
                placeholder: "Отработанные часы для себестоимости",
                value: _ctx.delivery_state.auto_duration,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.delivery_state.auto_duration) = $event)),
                "is-invalid": _ctx.state_form$.auto_duration.$error,
                "validation-errors": _ctx.state_form$.auto_duration.$errors
              }, null, 8, ["value", "is-invalid", "validation-errors"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        (_ctx.isOnTheWay)
          ? (_openBlock(), _createBlock(_component_checkbox, {
              key: 0,
              label: "Простой",
              class: "mt-3",
              value: _ctx.delivery_state.has_downtime,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.delivery_state.has_downtime) = $event)),
              disabled: _ctx.isModalLoading
            }, null, 8, ["value", "disabled"]))
          : _createCommentVNode("", true),
        (_ctx.delivery_state.has_downtime)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_radio_group, {
                name: "shipment_type",
                value: _ctx.delivery_state.downtime.type,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.delivery_state.downtime.type) = $event)),
                options: _ctx.FTL_ORDER_PAYMENT_RATE_TYPES,
                class: "small"
              }, null, 8, ["value", "options"]),
              _createVNode(_component_the_input, {
                class: "mt-3",
                placeholder: "Кол-во часов простоя для себестоимости",
                value: _ctx.delivery_state.downtime.hours,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.delivery_state.downtime.hours) = $event)),
                "is-invalid": _ctx.state_form$.downtime.hours.$error,
                "validation-errors": _ctx.state_form$.downtime.hours.$errors
              }, null, 8, ["value", "is-invalid", "validation-errors"]),
              _createVNode(_component_the_input, {
                class: "mt-3",
                placeholder: _ctx.getPlaceholder('Себестоимость простоя'),
                value: _ctx.delivery_state.downtime.cost_price,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.delivery_state.downtime.cost_price) = $event)),
                "is-invalid": _ctx.state_form$.downtime.cost_price.$error,
                "validation-errors": _ctx.state_form$.downtime.cost_price.$errors
              }, null, 8, ["placeholder", "value", "is-invalid", "validation-errors"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.delivery_state.additional_services.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delivery_state.additional_services, (service, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `service-${i}`,
                class: "mb-3"
              }, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(service.type_of_stock) + " (" + _toDisplayString(service.city_name) + ")", 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(service.type_name), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_11, [
                      _createTextVNode(" Поставщик "),
                      _createVNode(_component_info_icon, { class: "ServiceSubtitle__icon" }),
                      _hoisted_12
                    ]),
                    _createVNode(_component_the_select, {
                      class: "mt-2",
                      loading: _ctx.data_state.is_loading,
                      failed: _ctx.data_state.is_failed,
                      "error-text": "При получении списка произошла ошибка",
                      options: _ctx.data_state.list,
                      value: service.carrier_id,
                      "onUpdate:value": ($event: any) => ((service.carrier_id) = $event),
                      "search-without-refresh": "",
                      onRefresh: _cache[9] || (_cache[9] = ($event: any) => (_ctx.loadCarriers(_ctx.data_state.pagination.current_page))),
                      disabled: service.isSpark,
                      "is-invalid": !service.carrier_id && service.carrier_id !== 0
                    }, null, 8, ["loading", "failed", "options", "value", "onUpdate:value", "disabled", "is-invalid"])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_13, [
                      _createTextVNode(" Стоимость/час (тг) "),
                      _createVNode(_component_info_icon, { class: "ServiceSubtitle__icon" }),
                      _hoisted_14
                    ]),
                    _createVNode(_component_the_input, {
                      value: service.cost_per_hour,
                      "onUpdate:value": ($event: any) => ((service.cost_per_hour) = $event),
                      disabled: service.isSpark,
                      "is-invalid": !service.cost_per_hour && service.cost_per_hour !== 0
                    }, null, 8, ["value", "onUpdate:value", "disabled", "is-invalid"])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_checkbox, {
                      class: "mr-2",
                      value: service.isSpark,
                      "onUpdate:value": ($event: any) => ((service.isSpark) = $event),
                      disabled: _ctx.isModalLoading,
                      onChange: ($event: any) => (_ctx.onSparkChange(service))
                    }, null, 8, ["value", "onUpdate:value", "disabled", "onChange"]),
                    _createElementVNode("div", _hoisted_16, [
                      _createTextVNode(" за счет Spark-a "),
                      _createVNode(_component_info_icon, { class: "ServiceSubtitle__icon" }),
                      _hoisted_17
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_19, [
                      _createTextVNode(" Отработанные часы (ч) "),
                      _createVNode(_component_info_icon, { class: "ServiceSubtitle__icon" }),
                      _hoisted_20
                    ]),
                    _createVNode(_component_the_input, {
                      value: service.duration,
                      "onUpdate:value": ($event: any) => ((service.duration) = $event),
                      "is-invalid": !service.duration && service.duration !== 0
                    }, null, 8, ["value", "onUpdate:value", "is-invalid"])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_21, [
                      _createTextVNode(" Количество "),
                      _createVNode(_component_info_icon, { class: "ServiceSubtitle__icon" }),
                      _hoisted_22
                    ]),
                    _createVNode(_component_the_input, {
                      value: service.value,
                      "onUpdate:value": ($event: any) => ((service.value) = $event),
                      "is-invalid": !service.value && service.value !== 0
                    }, null, 8, ["value", "onUpdate:value", "is-invalid"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createTextVNode(" Общая себестоимость за доп. услугу (тг) "),
                    _createVNode(_component_info_icon, { class: "ServiceSubtitle__icon" }),
                    _hoisted_25
                  ]),
                  _createVNode(_component_the_input, {
                    value: service.cost_total,
                    "onUpdate:value": ($event: any) => ((service.cost_total) = $event),
                    disabled: service.isSpark,
                    "is-invalid": !service.cost_total && service.cost_total !== 0
                  }, null, 8, ["value", "onUpdate:value", "disabled", "is-invalid"])
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}